import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _extends from "@babel/runtime/helpers/extends";
var _excluded = ["children", "_leaf"];
var _window, _window$CNUI;
import { BLOCK, TILE } from "../../../common/util/const";
import { createBlockSnippet } from "../../../common/manager/setter-snippet";
var CnTooltip = (_window = window) === null || _window === void 0 ? void 0 : (_window$CNUI = _window.CNUI) === null || _window$CNUI === void 0 ? void 0 : _window$CNUI.CnTooltip;
var FUSION_UI_VIEW_PREFIX = 'fd-layout-view';
var addNewBlock = function addNewBlock(_leaf) {
  var _leaf$schema, _leaf$propsData, _leaf$propsData$norma, _leaf$document;
  var children = _leaf === null || _leaf === void 0 ? void 0 : (_leaf$schema = _leaf.schema) === null || _leaf$schema === void 0 ? void 0 : _leaf$schema.children;
  var defaultCardType = _leaf === null || _leaf === void 0 ? void 0 : (_leaf$propsData = _leaf.propsData) === null || _leaf$propsData === void 0 ? void 0 : (_leaf$propsData$norma = _leaf$propsData.normalStyle) === null || _leaf$propsData$norma === void 0 ? void 0 : _leaf$propsData$norma.defaultCardStyle;
  var prevBlockSchema = [].concat((Array.isArray(children) ? children : []) || []).reverse().find(function (n) {
    return typeof n === 'object' && [TILE, BLOCK].includes(n.componentName);
  }) || createBlockSnippet({
    defaultCardType: defaultCardType
  });
  var prevBlockProps = _extends({}, prevBlockSchema.props);
  delete prevBlockProps.operation;
  var blockSchema = createBlockSnippet({
    defaultCardType: defaultCardType
  });
  blockSchema.props = _extends({}, prevBlockProps, {
    span: 12
  });
  var newNode = _leaf === null || _leaf === void 0 ? void 0 : (_leaf$document = _leaf.document) === null || _leaf$document === void 0 ? void 0 : _leaf$document.createNode(blockSchema);
  newNode && (_leaf === null || _leaf === void 0 ? void 0 : _leaf.insertAfter(newNode));
  newNode && newNode.select();
};
export var AddTile = function AddTile(props) {
  var _ref = props || {},
    children = _ref.children,
    _leaf = _ref._leaf,
    others = _objectWithoutPropertiesLoose(_ref, _excluded);
  var dom = /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      return addNewBlock(_leaf);
    },
    className: FUSION_UI_VIEW_PREFIX + "-icon-add"
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 1024 1024",
    width: "24",
    height: "24",
    style: {
      transform: 'scale(0.5)',
      pointerEvents: 'none'
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M524.8 64c4.693333 0 8.533333 3.84 8.533333 8.533333V490.666667h418.133334c4.693333 0 8.533333 3.84 8.533333 8.533333v46.933333a8.533333 8.533333 0 0 1-8.533333 8.533334H533.333333v418.133333a8.533333 8.533333 0 0 1-8.533333 8.533333h-46.933333a8.533333 8.533333 0 0 1-8.533334-8.533333V554.666667H51.2a8.533333 8.533333 0 0 1-8.533333-8.533334v-46.933333c0-4.693333 3.84-8.533333 8.533333-8.533333H469.333333V72.533333c0-4.693333 3.84-8.533333 8.533334-8.533333h46.933333z",
    fill: "#FFF"
  })));
  return /*#__PURE__*/React.createElement("div", {
    className: FUSION_UI_VIEW_PREFIX + "-block-add"
  }, CnTooltip ? /*#__PURE__*/React.createElement(CnTooltip, {
    v2: true,
    align: "b",
    trigger: dom
  }, "\u5728\u5F53\u524D\u5E03\u5C40\u5BB9\u5668\u4E0B\u65B9\u6DFB\u52A0\u5757") : dom);
};